module.exports = __webpack_public_path__ + "img/1723011653044-WhatsApp Image 2024-08-07 at 12.02.12.jpeg.24dfa010.webp";